export default {
      id: "cash-flow-usage",
      viewBox: "0 0 27 32",
      url: __webpack_public_path__ + "sprite.svg#cash-flow",
      toString: function () {
        return this.url;
      }
    }